import React,{useEffect,useState} from 'react';
import { MdOutlineDateRange, MdDateRange } from 'react-icons/md';
import { FaDollarSign, FaUserCircle } from 'react-icons/fa';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import axios from '../api/api'

const Home = () => {
  // user details
  const name = window.localStorage.getItem('token');
  const parsedItem = JSON.parse(name);
  const user = JSON.parse(name).data._id;

  const [stats,setStats] = useState('')
  const [creatorStats,setCreatorStats] = useState('')

  
  useEffect(() => {
    const getMetrics = async () => {
      const response = await axios.get('/api/v7/admin/metrics')
      setStats(response.data.metrics)
    }
    getMetrics()
  },[])

  useEffect(() => {
    const getCreatorMetrics = async (id) => {
      const resp = await axios.get(`/api/v7/creator/metrics/${user}`)
      setCreatorStats(resp.data.metrics)
    }
    getCreatorMetrics()
  },[user])

  const data = [
    {
      name: 'Page A',
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: 'Page B',
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: 'Page C',
      uv: 2000,
      pv: 9800,
      amt: 2290,
    },
    {
      name: 'Page D',
      uv: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
      name: 'Page E',
      uv: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
      name: 'Page F',
      uv: 2390,
      pv: 3800,
      amt: 2500,
    },
    {
      name: 'Page G',
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
  ];
  

  return (
    <main>
      <div className='mx-auto p-4 lg:container'>
        <div className='p-6 text-white bg-[#181D31] rounded-lg'>
          <h2>Hello {parsedItem.data.role === 'admin' ? ('Admin') : (parsedItem.data.productionName)}</h2>
          <p>This is what we've got for you today.</p>
        </div>
        {
          parsedItem.data.role !== 'admin'
            ? (
              <div>
                <div className='grid grid-cols-1 gap-4 mt-8 md:grid-cols-2 lg:grid-cols-4'>
                  <div className='bg-white'>
                    <div className='flex justify-between text-right p-4'>
                      <span className='text-4xl bg-emerald-700 text-white p-4 -top-8 rounded-md'>
                        <FaDollarSign />
                      </span>
                      <div>
                        <h6>TOTAL AMOUNT</h6>
                        <span>{creatorStats.totalAmount}</span>
                      </div>
                    </div>
                    <hr />
                    <br />
                    <br />
                  </div>
                  <div className='bg-white'>
                    <div className='flex justify-between text-right p-4'>
                      <span className='text-4xl bg-red-700 text-white p-4 -top-8 rounded-md'>
                        <FaUserCircle />
                      </span>
                      <div>
                        <h6>TOTAL VIEWS</h6>
                        {/* <span>{creatorStats.totalAmount}</span> */}
                      </div>
                    </div>
                    <hr />
                    <br />
                    <br />
                  </div>
                  <div className='bg-white'>
                    <div className='flex justify-between text-right p-4'>
                      <span className='text-4xl bg-teal-500 text-white p-4 -top-8 rounded-md'>
                        <MdDateRange />
                      </span>
                      <div>
                        <h6>TOTAL UPLOADS</h6>
                        <span>{creatorStats.totalUploads}</span>
                      </div>
                    </div>
                    <hr />
                    <br />
                    <br />
                  </div>
                </div>
              </div>
              )
            : (
              <div>
                <div className='md:grid grid-cols-4 gap-4 mt-8'>
                  <div className='bg-white'>
                    <div className='flex justify-between text-right p-4'>
                      <span className='text-4xl bg-orange-500 text-white p-4 -top-8 rounded-md'>
                        <MdOutlineDateRange />
                      </span>
                      <div>
                        <h6>TODAY BOOKING</h6>
                      </div>
                    </div>
                    <hr />
                    <br />
                    <br />
                  </div>
                  <div className='bg-white'>
                    <div className='flex justify-between text-right p-4'>
                      <span className='text-4xl bg-emerald-700 text-white p-4 -top-8 rounded-md'>
                        <FaDollarSign />
                      </span>
                      <div>
                        <h6>TOTAL AMOUNT</h6>
                        <span>{stats.totalAmount} Naira</span>
                      </div>
                    </div>
                    <hr />
                    <br />
                    <br />
                  </div>
                  <div className='bg-white'>
                    <div className='flex justify-between text-right p-4'>
                      <span className='text-4xl bg-red-700 text-white p-4 -top-8 rounded-md'>
                        <FaUserCircle />
                      </span>
                      <div>
                        <h6>TOTAL USERS</h6>
                        <span>{stats.totalUploads}</span>
                      </div>
                    </div>
                    <hr />
                    <br />
                    <br />
                  </div>
                  <div className='bg-white'>
                    <div className='flex justify-between text-right p-4'>
                      <span className='text-4xl bg-teal-500 text-white p-4 -top-8 rounded-md'>
                        <MdDateRange />
                      </span>
                      <div>
                        <h6>TOTAL UPLOADS</h6>
                        <span>{stats.userCount}</span>
                      </div>
                    </div>
                    <hr />
                    <br />
                    <br />
                  </div>
                </div>
                <ResponsiveContainer width="100%" height="100%">
                  <LineChart
                    width={500}
                    height={300}
                    data={data}
                    margin={{
                      top: 5,
                      right: 30,
                      left: 20,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line type="monotone" dataKey="pv" stroke="#8884d8" activeDot={{ r: 8 }} />
                    <Line type="monotone" dataKey="uv" stroke="#82ca9d" />
                  </LineChart>
                </ResponsiveContainer>
              </div>
              )
        }
      </div>
    </main>
  );
};

export default Home;
